import { FC } from "react";

export const LeftArrow: FC<{ width?: number, height?: number, className?: string }> = ({
    width = 24, height = 24, className = "" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 24 24" fill="none" className={className}>
            <path d="M9.57 5.92969L3.5 11.9997L9.57 18.0697" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.4999 12H3.66992" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const RightArrow: FC<{ width?: number, height?: number, className?: string }> = ({
    width = 24, height = 24, className = "" }) => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 24 24" fill="none" className={className}>
        <path d="M14.4297 5.92969L20.4997 11.9997L14.4297 18.0697" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.5 12H20.33" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>);
};